import { useNavigate } from 'react-router-dom';

import { Button } from '../components/Button';
import { ErrorState } from '../components/States';

/** The 403 not-authorised screen shown when a role reaches a route it may not use. */
export function ForbiddenScreen(): React.JSX.Element {
  const navigate = useNavigate();
  return (
    <div style={{ padding: 20, maxWidth: 640, margin: '0 auto' }}>
      <ErrorState
        title="You don't have access to this"
        body="Your role doesn't permit this area. If you think that's wrong, ask a workspace admin to update your access."
        actions={
          <Button
            onClick={() => {
              void navigate('/dashboard');
            }}
          >
            Back to dashboard
          </Button>
        }
      />
    </div>
  );
}
